<template>
  <div class="wrapper">
    <div class="photo-container" :key="componentKey">
      <div v-if="situation && situation.media">
        <img :src="`/demo/photo/${situation.media.filename}`" class="photo" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1680 500"
          preserveAspectRatio="xMinYMin meet"
          class="svgMask"
        >
          <g fill="none" stroke="#000">
            <path
              d="M742.602 277.688c-3.155 1.286-8.11 4.148-12.788 9.199-13.3 9.781-4.688 61.696 12.34 74.709 6.805 4.334 13.61 3.708 20.416 5.384 8.113.615 15.741-.469 22.66-4.038 7.107-3.446 14.195-6.394 19.069-20.865 6.498-8.126 8.974-37.467 8.974-37.467 1.052-8.307-2.237-14.352-7.404-20.416-10.22-5.083-21.113-8.152-32.53-9.647zM848.047 287.335c8.253-13.568 22.281-17.683 37.018-20.64 15.35-1.61 30.4-2.616 43.973-.673 14.98.557 20.97 9.63 24.679 20.865 4.11 16.906 2.854 31.374.448 45.319-2.348 16.508-8.48 18.953-13.012 21.537-28.57 11.648-37.071 7.526-49.806 6.73-13.747-4.714-26.334-10.781-32.98-23.78-7.48-10.827-9.91-22.776-12.114-34.775.248-5.56.39-11.335 1.794-14.583z"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Photo',
  data() {
    return {
      componentKey: 0,
    };
  },
  computed: {
    //get the current situation
    situation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
  },
  //Force re render component when idSituation change
  watch: {
    '$route.params.idSituation': function() {
      this.forceRerender();
    },
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
}
.photo-container {
  margin: auto;
  position: relative;
}
.svgMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.svgMask g {
  fill: black;
  opacity: 0.5;
}
.photo {
  width: 100%;
}

/* @media screen and (max-width: 1920px) {
  .photo-container {
    width: 90%;
  }
}
@media screen and (max-width: 1440px) {
  .photo-container {
    width: 80%;
  }
}

@media screen and (max-width: 1280px) {
  .photo-container {
    width: 100%;
  }
} */
</style>
